module.exports = "<router-outlet>\n    <!-- <ngx-spinner bdColor=\"rgba(51,51,51,0.8)\" size=\"medium\" color=\"#fff\" type=\"ball-scale-multiple\">\n        <p style=\"font-size: 20px; color: white\">Loading...</p>\n    </ngx-spinner> -->\n    <ngx-spinner bdColor=\"rgba(51, 51, 51, 0.8)\" size=\"default\" color=\"#ffffff\" type=\"timer\"></ngx-spinner>\n    <app-spinner></app-spinner>\n</router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main